import { render, staticRenderFns } from "./PersonalityCompareCard.vue?vue&type=template&id=314c1f8a&"
import script from "./PersonalityCompareCard.vue?vue&type=script&lang=js&"
export * from "./PersonalityCompareCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports